export type StripeOutcome = {
  settled: boolean;
  ok: boolean;
  status: string;
  message: string;
};

export const describePaymentIntent = (status?: string): StripeOutcome => {
  switch (status) {
    case 'succeeded':
      return { settled: true, ok: true, status, message: 'Payment confirmed.' };
    case 'processing':
      return {
        settled: true,
        ok: true,
        status,
        message: 'Your payment is processing. We will email you once the bank confirms it.',
      };
    case 'requires_capture':
      return {
        settled: true,
        ok: true,
        status,
        message: 'Your card was authorized. The school will capture the payment.',
      };
    case 'requires_action':
    case 'requires_confirmation':
      return {
        settled: false,
        ok: false,
        status,
        message: 'Your bank needs to confirm this payment. Please complete the verification and try again.',
      };
    case 'requires_payment_method':
      return { settled: false, ok: false, status, message: 'That card was declined. Please try another card.' };
    case 'canceled':
      return { settled: false, ok: false, status, message: 'This payment was canceled. Please start again.' };
    default:
      return {
        settled: false,
        ok: false,
        status: status || 'unknown',
        message: 'We could not confirm this payment. Please contact the school before trying again.',
      };
  }
};

export const describeSetupIntent = (status?: string): StripeOutcome => {
  switch (status) {
    case 'succeeded':
      return { settled: true, ok: true, status, message: 'Success! Your payment method has been saved.' };
    case 'processing':
      return {
        settled: true,
        ok: true,
        status,
        message: 'Processing payment details. We will update you when processing is complete.',
      };
    case 'requires_action':
    case 'requires_confirmation':
      return {
        settled: false,
        ok: false,
        status,
        message: 'Your bank needs to confirm this card. Please complete the verification and try again.',
      };
    case 'requires_payment_method':
      return {
        settled: false,
        ok: false,
        status,
        message: 'Failed to process payment details. Please try another payment method.',
      };
    case 'canceled':
      return { settled: false, ok: false, status, message: 'Saving this payment method was canceled.' };
    default:
      return {
        settled: false,
        ok: false,
        status: status || 'unknown',
        message: 'We could not save this payment method. Please try again.',
      };
  }
};

export const requiresRegistrationPayment = (fee?: number | string | null): boolean => {
  const amount = Number(fee || 0);
  return Number.isFinite(amount) && amount > 0;
};
